function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 1.37305,
  y: 0.5,
  width: 3,
  height: 10,
  stroke: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 7.37305,
  y: 0.5,
  width: 3,
  height: 10,
  stroke: "currentColor"
});

function SvgIcPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjEuMzczMDUiIHk9IjAuNSIgd2lkdGg9IjMiIGhlaWdodD0iMTAiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+CiAgICA8cmVjdCB4PSI3LjM3MzA1IiB5PSIwLjUiIHdpZHRoPSIzIiBoZWlnaHQ9IjEwIiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgIcPause as ReactComponent };